import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
    const isAuthenticated = isAuthenticatedFunction();

    return isAuthenticated ? children : <Navigate to="/" replace />;
};

const isAuthenticatedFunction = () => {
    let token = localStorage.getItem("jwt-vlada");
    if (!token) {
        return;
    };

    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000 > Date.now();
    } catch (error) {
        return false;
    }
};

export default AdminRoute;